<template>
  <multiple_form
    :forms="forms"
    :edit="true"
    :editData="props.editData"
    :disabled="true"
    :submitBtn="false"
    :isScroll="false"
  />
</template>
<script setup>
  import { defineProps, defineEmits, computed } from 'vue'
  import { message } from 'ant-design-vue'
  import { approval } from '@/api/person_application/person_application_approval'
  import multiple_form from '@/components/multiple_form'
  import { gender, yesOrNot } from '@/utils/common'
  import { constantToOptions } from '@/utils/format'
  //初始化
  const props = defineProps({
    editData: Object,
    data: Array,
    idField: String,
  })
  const emit = defineEmits(['submit'])

  //表单
  const forms = computed(() => [
    {
      name: '来访人员信息',
      id: 'visitor',
      formItem: [
        {
            type: 'input',
            field: 'application_number',
            label: '人员预约单号'
        },
        {
          type: 'input',
          field: 'visitor_name',
          label: '姓名',
        },

        {
          type: 'radio',
          field: 'visitor_gender',
          options: constantToOptions(gender),
          label: '性别',
        },
        {
          type: 'input',
          field: 'visitor_nation',
          label: '民族',
        },
        // {
        //   type: 'input',
        //   field: 'visitor_education',
        //   label: '学历',
        // },
        {
          type: 'input',
          field: 'visitor_phone',
          label: '手机号码',
        },
        // {
        //   type: 'radio',
        //   field: 'veteran',
        //   options: constantToOptions(yesOrNot),
        //   label: '退役军人',
        // },
        {
          type: 'input',
          field: 'visitor_company',
          label: '申请人工作单位',
        },
        {
          type: 'input',
          field: 'visitor_address',
          label: '申请人现住址(详细)',
        },
        {
          type: 'radio',
          storeOptions: 'personVisitType',
          field: 'visitor_type',
          label: '访客类型',
        },
        {
          type: 'select',
          field: 'visitor_idcard_type',
          storeOptions: 'documentType',
          label: '证件类型',
        },
        {
          type: 'input',
          field: 'visitor_idcard',
          label: '证件号码',
        },
        {
          type: 'image',
          field: 'visitor_face_photo',
          label: '人脸图片',
        },
        {
          type: 'image',
          field: 'visitor_idcard_photo1',
          label: '证件图片-人像面(原件)',
        },
        {
          type: 'image',
          field: 'visitor_idcard_photo2',
          label: '证件图片-国徽面(原件)',
        },
      ],
    },
    {
      name: '来访信息',
      id: 'visit',
      formItem: [
        {
          type: 'input',
          field: 'visit_content',
          label: '访问事由',
        },
        {
          type: 'dateRange',
          startField: 'visit_begin_time',
          endField: 'visit_end_time',
          label: '来访/截止时间',
        },
        {
          type: 'select',
          field: 'visit_area',
          label: '申请园区',
          storeOptions: 'areaType',
        },
      ],
    },
    {
      name: '被访信息',
      id: 'interviewee',
      formItem: [
        {
          type: 'input',
          field: 'interviewee_name',
          label: '被访问人',
        },
        {
          type: 'input',
          field: 'interviewee_phone',
          label: '被访问人电话',
        },
        {
          type: 'select',
          field: 'interviewee_depart_id',
          storeOptions: 'dept',
          label: '被访问单位',
        },
      ],
    },
  ])
</script>
